import { invert as _invert } from "lodash";
import {
  packageCode,
  codigosTarjetas,
  nombresTarjetas,
  nombresPaquetes
} from "@/config/constants/packagesCodes";
import { cashbackPaquetes } from "@/config/constants/packageAwards";
import { formatDinero } from "../../utils";

//-----------------Return descripción de tarjeta mediante código de tarjeta-----------------//
const descripCodeTarjeta = tipoTarjeta => {
  let descripcionTipoTarjeta = "";
  switch (tipoTarjeta) {
    case codigosTarjetas.VISA_INTERNACIONAL:
      descripcionTipoTarjeta = nombresTarjetas.VISA_INTERNACIONAL;
      break;
    case codigosTarjetas.VISA_GOLD:
      descripcionTipoTarjeta = nombresTarjetas.VISA_GOLD;
      break;
    case codigosTarjetas.VISA_PLATINUM:
      descripcionTipoTarjeta = nombresTarjetas.VISA_PLATINUM;
      break;
    case codigosTarjetas.VISA_SIGNATURE:
      descripcionTipoTarjeta = nombresTarjetas.VISA_SIGNATURE;
      break;
    case codigosTarjetas.MASTERCARD_GOLD:
      descripcionTipoTarjeta = nombresTarjetas.MASTERCARD_GOLD;
      break;
    case codigosTarjetas.MASTERCARD_INTERNACIONAL:
      descripcionTipoTarjeta = nombresTarjetas.MASTERCARD_INTERNACIONAL;
      break;
    case codigosTarjetas.MASTERCARD_PLATINUM:
      descripcionTipoTarjeta = nombresTarjetas.MASTERCARD_PLATINUM;
      break;
    case codigosTarjetas.MASTERCARD_BLACK:
      descripcionTipoTarjeta = nombresTarjetas.MASTERCARD_BLACK;
  }
  return descripcionTipoTarjeta;
};

/**
 * Generar bullets para límites de tarjetas en oferta
 * @param {Array} tarjetas Array de tarjetas de la oferta
 */
export const ofertaLimitesDeTarjetas = tarjetas => {
  const masDeUnaTj = tarjetas.length > 1;
  const a = masDeUnaTj ? "- " : "";
  let bullets = "";
  for (let i = 0; i < tarjetas.length; i++) {
    let b = masDeUnaTj && i < tarjetas.length - 1 ? "<br>" : "";
    let nombre = masDeUnaTj
      ? `${a}Tarjeta de crédito ${descripCodeTarjeta(tarjetas[i].tipoTarjeta)}`
      : "";
    bullets += `${nombre}${
      masDeUnaTj ? " con" : "Con"
    } un límite de compra de $<span data-obfuscate>${formatDinero(
      tarjetas[i].limite
    )}${b}</span>`;
  }
  return bullets;
};

//------------------Return true si el paquete tiene cajas de ahorro en dolares------------------//
const tieneCAenDolares = (tipoPaquete, cajasDeAhorro) => {
  if (!cajasDeAhorro) return false;
  return cajasDeAhorro.find(c => c.moneda === "DOL") != undefined;
};

//--------------------------------retorna array de limites de tarjeta para thank you page--------------------------------//
const ofertaLimitesDeTarjetasTYP = tarjetas => {
  let bullets = [];
  for (let i = 0; i < tarjetas.length; i++) {
    bullets[i] = `Tarjeta de crédito ${descripCodeTarjeta(
      tarjetas[i].tipoTarjeta
    )} con un límite de compra de $<span data-obfuscate>${formatDinero(
      tarjetas[i].limite
    )}</span>`;
  }
  return bullets;
};

//-------------------------------Return nombre tarjeta débito-------------------------------//
export const nombreTarjetaDebito = tipoPaquete => {
  switch (tipoPaquete) {
    case packageCode.LIBRETON_PREMIUM:
      return "Tarjeta Visa Débito Premium";
    case packageCode.LIBRETON_PREMIUM_WORLD:
      return "Tarjeta Visa Débito Premium World";
    default:
      return "Tarjeta Visa Débito";
  }
};

//------------------Return descripción de tarjetas incluidas en el paquete------------------//
const descripcionTarjetasIncluidas = tarjetas => {
  let descripcionTarjeta = "";
  tarjetas.forEach((tarjeta, index) => {
    descripcionTarjeta += `${descripCodeTarjeta(tarjeta.tipoTarjeta)}${
      index === 0 && tarjetas.length > 1 ? " y " : ""
    }`;
  });
  return descripcionTarjeta;
};

//----------------------------------Return credito total----------------------------------//
const totalCredito = tarjetas => {
  let totalLimite = 0;
  for (const tarjeta of tarjetas) {
    totalLimite += tarjeta.limite;
  }
  return formatDinero(totalLimite);
};

//-------------------Return slugs de tarjetas de crédito en el paquete-------------------//
const tarjetasCreditoIncluidas = tarjetasPaquete => {
  let nombresTarjetasPorCodigo = _invert(codigosTarjetas);
  return tarjetasPaquete.map(tarjeta => {
    let nombre = nombresTarjetasPorCodigo[tarjeta.tipoTarjeta];
    return nombre ? nombre.toLowerCase().replace("_", "-") : "";
  });
};

//-------------------Return listado de tarjetas de credito y débito incluídas-------------------//
const tarjetasIncluidas = (tipoPaquete, tarjetasPaquete) => {
  // Obtener códigos de tarjetas del servicio
  let tarjetas = tarjetasCreditoIncluidas(tarjetasPaquete);
  // Agregar tarjeta de débito por paquete
  switch (tipoPaquete) {
    case packageCode.LIBRETON_PREMIUM:
      tarjetas = [...tarjetas, "visa-debito-premium"];
      break;
    case packageCode.LIBRETON_PREMIUM_WORLD:
      tarjetas = [...tarjetas, "visa-debito-premium-world"];
      break;
    default:
      tarjetas = [...tarjetas, "visa-debito-nacional"];
  }
  return tarjetas;
};

//---------------------------------Premio por paquete---------------------------------//
const premioPaquete = tipoPaquete => {
  let premio = {
    label: "",
    description:
      "Como premio de bienvenida una vez que acredites tu sueldo en BBVA"
  };
  switch (tipoPaquete) {
    case packageCode.LIBRETON_PREMIUM:
      premio.label = `<strong><span data-obfuscate>${cashbackPaquetes.LIBRETON_PREMIUM}</span> a tu favor</strong> en la tarjeta de crédito Visa`;
      break;
    case packageCode.LIBRETON_PREMIUM_WORLD:
      premio.label = `<strong><span data-obfuscate>${cashbackPaquetes.LIBRETON_PREMIUM_WORLD}</span> a tu favor</strong> en la tarjeta de crédito Visa`;
      break;
    case packageCode.LIBRETON_FULL:
      premio.label = `<strong><span data-obfuscate>${cashbackPaquetes.LIBRETON_FULL}</span> a tu favor</strong> en la tarjeta de crédito Visa Gold`;
      break;
    case packageCode.LIBRETON_PLUS_GOLD:
      premio.label = `<strong><span data-obfuscate>${cashbackPaquetes.LIBRETON_PLUS_GOLD}</span> a tu favor</strong> en la tarjeta de crédito Visa Gold`;
      break;
    case packageCode.LIBRETON_EXPRESS:
      premio.label = `<strong><span data-obfuscate>${cashbackPaquetes.LIBRETON_EXPRESS}</span> a tu favor</strong> en la tarjeta de crédito Visa Internacional`;
      break;
    default:
      premio.description = "";
  }
  return premio;
};

//-------------------------Valores de costo mantenimiento-------------------------//
const costoMantenimiento = tipoPaquete => {
  const costos = {
    [packageCode.LIBRETON_PREMIUM]: "81.000",
    [packageCode.LIBRETON_PREMIUM_WORLD]: "91.000",
    [packageCode.LIBRETON_PLUS_GOLD]: "55.000",
    [packageCode.LIBRETON_FULL]: "45.000",
    default: "34.000"
  };
  return costos[tipoPaquete] || costos.default;
};

//------------------------------Cashback del paquete-------------------------------//

const beneficioExtra = tipoPaquete => {
  let beneficio = {
    label: "",
    description: "A tu favor en tu tarjeta de crédito Visa"
  };
  switch (tipoPaquete) {
    case packageCode.LIBRETON_FULL:
      beneficio.label = cashbackPaquetes.LIBRETON_FULL;
      break;
    case packageCode.LIBRETON_PREMIUM:
      beneficio.label = cashbackPaquetes.LIBRETON_PREMIUM;
      break;
    case packageCode.LIBRETON_PREMIUM_WORLD:
      beneficio.label = cashbackPaquetes.LIBRETON_PREMIUM_WORLD;
      break;
    case packageCode.LIBRETON_PLUS_GOLD:
      beneficio.label = cashbackPaquetes.LIBRETON_PLUS_GOLD;
      break;
    case packageCode.LIBRETON_EXPRESS:
      beneficio.label = cashbackPaquetes.LIBRETON_EXPRESS;
      break;
    default:
      //No posee cashback
      beneficio.description = "";
  }
  return beneficio;
};

export const paquetesBeneficios = paquetes => {
  //----------------------------------CONSTANTES----------------------------------//
  const tarjetasEnPaquete = tarjetasIncluidas(
    paquetes.tipoPaquete,
    paquetes.tarjetas
  );
  const premioPorPaquete = premioPaquete(paquetes.tipoPaquete);
  const precioMantenimiento = costoMantenimiento(paquetes.tipoPaquete);
  const cashback = beneficioExtra(paquetes.tipoPaquete);

  //---------------------------Formateo descripción número de tarjetas---------------------------//
  const numeroTarjetas = tarjetas => {
    return tarjetas.length > 1 ? `entre las ${tarjetas.length} tarjetas` : "";
  };

  //-------------------------------Nombre tarjeta/tarjetas-------------------------------//
  const nombreTarjetas = nroTarjetas => {
    return nroTarjetas > 1 ? "Tarjetas de crédito " : "Tarjeta de crédito ";
  };

  //---------------------------Formateo programa Millas BBVA---------------------------//
  const labelPuntosBBVA = tipoPaquete => {
    let label = "";
    switch (tipoPaquete) {
      case packageCode.LIBRETON_PREMIUM:
      case packageCode.LIBRETON_PREMIUM_WORLD:
        label = "Te adherimos al programa Millas BBVA";
        break;
      default:
    }
    return label;
  };

  //--------------------------------Formateo programa Millas BBVA--------------------------------//
  const descripcionProgramaPuntos = tipoPaquete => {
    let descripcionPrograma = "";

    switch (tipoPaquete) {
      case packageCode.LIBRETON_PREMIUM:
      case packageCode.LIBRETON_PREMIUM_WORLD:
        descripcionPrograma = `Acumulá millas por tus consumos con tarjeta de crédito BBVA y canjealos por viajes, paquetes y muchas experiencias más.`;
        break;
      default:
    }
    return descripcionPrograma;
  };

  //------------------------------Helpers para tagging----------------------------------//
  const taggingCajasDeAhorro = () => {
    let cajasDeAhorro = [
      {
        descripcion: "CAJA DE AHORRO PESOS",
        moneda: "ARS"
      }
    ];

    return cajasDeAhorro;
  };

  //------------------------------Return info del paquete-------------------------------//

  let infoPaquete = {
    incluye: {
      titulo: "¿Qué incluye esta oferta?",
      items: [
        {
          label: `<strong>${nombreTarjetas(paquetes.tarjetas.length)}
          ${descripcionTarjetasIncluidas(paquetes.tarjetas)}</strong>`,
          description: `${ofertaLimitesDeTarjetas(paquetes.tarjetas)}`
        },
        {
          label: `<strong>${nombreTarjetaDebito(
            paquetes.tipoPaquete
          )}</strong>`,
          description: ""
        },
        ...(tieneCAenDolares(paquetes.tipoPaquete, paquetes.cajasDeAhorro)
          ? [
              {
                label: "Caja de ahorro en dólares",
                labelOferta: "Caja de ahorro en dólares",
                description: "",
                nobullet: true,
                type: "ca"
              }
            ]
          : [])
      ],
      tarjetas: tarjetasEnPaquete
    },
    beneficios: {
      titulo: "Y te damos éstos beneficios:",
      items: [
        {
          label:
            "<strong>El mantenimiento de tu cuenta será <span data-obfuscate>100%</span> bonificado</strong>",
          description: `Mientras acredites tu sueldo en BBVA. <span>Te bonificamos 3 meses el costo de mantenimiento de la ${nombresPaquetes(
            paquetes.tipoPaquete
          )} para que puedas hacer el trámite con tu empleador.</span>`
        },
        {
          label: `${labelPuntosBBVA(paquetes.tipoPaquete)}`,
          description: `${descripcionProgramaPuntos(paquetes.tipoPaquete)}`
        },
        {
          label:
            "Adherite gratis a nuestro programa <strong>Go</strong> y ahorrá en tus compras",
          description:
            "Comprando con tu tarjeta de crédito accedés a todos los beneficios."
        }
      ]
    },
    gracias: {
      items: [
        {
          label:
            "Cuenta <span data-obfuscate>100%</span> bonificada mientras acredites tu sueldo con nosotros",
          description: ""
        },
        {
          label: nombreTarjetaDebito(paquetes.tipoPaquete),
          description: ""
        },
        {
          label: `<span data-obfuscate>${premioPorPaquete.label}</span>`,
          description: `${premioPorPaquete.description}`
        },
        ...(tieneCAenDolares(paquetes.tipoPaquete, paquetes.cajasDeAhorro)
          ? [
              {
                label: "Caja de ahorro en dólares",
                description: ""
              }
            ]
          : [
              {
                label: "",
                description: ""
              }
            ])
      ]
    },
    caracteristicas: {
      tipoPaquete: paquetes.tipoPaquete,
      limite: `${totalCredito(paquetes.tarjetas)}`,
      limiteDescripcion: `${numeroTarjetas(paquetes.tarjetas)}`,
      nombreTarjetas: `${nombreTarjetas(paquetes.tarjetas.length) +
        descripcionTarjetasIncluidas(paquetes.tarjetas)}`,
      nTarjetas: paquetes.tarjetas.length,
      tiempo: `1 año`,
      tiempoDescripcion: `de bonificación<br> en tu cuenta.`,
      porcentajeBonificacion: `100%`,
      porcentajeDescripcion: `de bonificacion<br> en tu cuenta.`,
      mantenimiento: `${precioMantenimiento}`,
      mantenimientoDescripcion: `mantenimiento mensual<br> que te ahorrás<br> mientras acredites tu sueldo.`,
      mantenimientoBonificado: true,
      beneficioExtra: "",
      beneficioExtraDescripcion: "",
      tarjetas: paquetes.tarjetas,
      tarjetasDescripcion: paquetes.tarjetas.map(tarjeta =>
        descripCodeTarjeta(tarjeta.tipoTarjeta)
      )
    },
    millasLatamPass: cashback,
    disclaimer: "",
    detalleSolicitud: [
      `Tarjeta de crédito ${descripcionTarjetasIncluidas(paquetes.tarjetas)}`,
      `${nombreTarjetaDebito(paquetes.tipoPaquete)}`,
      `Caja de ahorro pesos`,
      `Cuenta 100% bonificada.`,
      `Límite de compra de $ ${totalCredito(
        paquetes.tarjetas
      )} ${numeroTarjetas(paquetes.tarjetas)}`
    ],
    productsTagging: {
      paquetes: [
        {
          descripcion: paquetes.descripcion,
          tipoPaquete: paquetes.tipoPaquete,
          tarjetas: paquetes.tarjetas,
          cajasDeAhorro: taggingCajasDeAhorro()
        }
      ]
    }
  };

  if (premioPorPaquete.label) {
    infoPaquete.beneficios.items.unshift({
      label: `<strong>${premioPorPaquete.label}</strong>`,
      description: premioPorPaquete.description
    });
  }

  //Se agrega el limite de compra de las tarjetas de crédito en el 2do bullet.
  const limitesTarjetas = ofertaLimitesDeTarjetasTYP(paquetes.tarjetas);
  if (limitesTarjetas.length > 0) {
    limitesTarjetas.forEach(value => {
      infoPaquete.gracias.items.splice(1, 0, { label: value, description: "" });
    });
  }

  //Filtro los items vacíos (que no corresponden)
  console.log("Items antes del filtro:", infoPaquete.incluye.items);
  infoPaquete.incluye.items = infoPaquete.incluye.items.filter(
    item => item.label !== ""
  );
  infoPaquete.beneficios.items = infoPaquete.beneficios.items.filter(
    item => item.label !== ""
  );
  infoPaquete.gracias.items = infoPaquete.gracias.items
    .filter(item => item.label !== "")
    .map(item => (item = item.label + "<br/>" + item.description));

  return infoPaquete;
};
